import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalHook() {
  return <section className="py-24 px-4 bg-[#F5F0E8] text-center" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-57">
          <h2 className="font-serif text-3xl md:text-4xl text-[#3D3229] mb-8 italic" data-id="element-58">
            "¿Lo estaré haciendo bien?"
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-[#5C4A3A] leading-relaxed" data-id="element-59">
            <p data-id="element-60">
              Sabemos lo que se siente... Llegar al final del día agotada, con
              la sensación de haber apagado mil fuegos pero sin saber si
              realmente estás conectando con tus hijos.
            </p>
            <p data-id="element-61">
              La crianza es el viaje más hermoso, pero también puede ser
              solitario y abrumador cuando te enfrentas a desafíos para los que
              nadie te preparó: rabietas que parecen interminables, noches sin
              dormir, o dudas constantes sobre su salud y bienestar.
            </p>
            <p className="font-medium text-[#3D3229]" data-id="element-62">
              No estás sola en esto. Y lo más importante: no tienes por qué
              hacerlo sola.
            </p>
          </div>

          <div className="mt-12 flex justify-center" data-id="element-63">
            <div className="w-24 h-1 bg-[#5A7D60]/30 rounded-full" data-id="element-64" />
          </div>
        </motion.div>
      </div>
    </section>;
}